import { render, staticRenderFns } from "./SelectDicName.vue?vue&type=template&id=2e785ba1&scoped=true"
import script from "./SelectDicName.vue?vue&type=script&lang=js"
export * from "./SelectDicName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e785ba1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e785ba1')) {
      api.createRecord('2e785ba1', component.options)
    } else {
      api.reload('2e785ba1', component.options)
    }
    module.hot.accept("./SelectDicName.vue?vue&type=template&id=2e785ba1&scoped=true", function () {
      api.rerender('2e785ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DicValue/SelectDicName.vue"
export default component.exports